import React from 'react';
import { AppContext } from '../AppContext';


const MoreGames = (props) => {
    const app = React.useContext(AppContext);
    const marketPlace = app.marketPlace;

    React.useEffect(() => {
        app.achievements.awardAchivement(app.userdata, "See More Games");
    }, []);

    const showGame = function (name) {
        console.log(`show game ${name}`);
        marketPlace.show(name);
    };

    const games = marketPlace.getGames();

    const listItems = games.map((game) =>
        <li key={game.name} className={'button button' + game.name} onClick={() => showGame(game.name)}>{game.name}</li>
    );

    return (
        <div id="MoreGames" className="page1">
            <div className="wrapper">
                <div className="pageTitle">
                    <a className="backButton" href="#"></a>
                    <h1 className="title" >More Games</h1>
                </div>
                <div className='content-narrow'>
                    <ul className='buttonList'>
                        {listItems}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MoreGames;

